"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
class UnknownError extends Error {
    constructor(msg) {
        super(msg ? `UnknownError: ${msg}` : "UnknownError");
    }
}
exports.UnknownError = UnknownError;
//# sourceMappingURL=UnknownError.js.map